/**
 * Guided-planning host for the shared coverage-assessment introduction: guided wording ("Step 1"),
 * wizard Back/Next, Back hidden on the wizard's first step, rendered inside `StepLayout`.
 */
import { useWizard } from 'react-use-wizard';

import { AssessmentIntroduction } from '@/features/funding-sources';
import { StepLayout } from '@/features/guided-financial-planning/components/step-layout';

export function AssessmentIntroStep() {
  const { nextStep, previousStep, isFirstStep } = useWizard();

  return (
    <AssessmentIntroduction
      stepLabel="Step 1"
      onContinue={nextStep}
      onBack={isFirstStep ? undefined : previousStep}
      frame={parts => (
        <StepLayout
          title={parts.title}
          subtitle={parts.subtitle}
          icon={parts.icon}
          nextButtonLabel={parts.primaryAction?.label}
          onNext={parts.primaryAction?.onSelect}
          onBack={parts.backAction?.onSelect}
          hideBack={!parts.backAction}
        >
          {parts.content}
        </StepLayout>
      )}
    />
  );
}
